var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2428 4.11326H5.4646C3.88123 4.11326 2.59766 5.39679 2.59766 6.98011V16.5364C2.59766 18.1197 3.88123 19.4032 5.4646 19.4032H15.0211C16.6044 19.4032 17.888 18.1197 17.888 16.5364L17.888 11.7582M7.37589 14.625L10.8528 13.9245C11.0374 13.8873 11.2069 13.7964 11.34 13.6632L19.1235 5.87572C19.4967 5.50235 19.4964 4.89713 19.1229 4.52407L17.4741 2.87717C17.1008 2.50426 16.4958 2.50452 16.1228 2.87774L8.33852 10.6661C8.20567 10.799 8.11496 10.9681 8.07774 11.1523L7.37589 14.625Z",
    stroke: "#8B8B8B",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcons);
export default __webpack_public_path__ + "static/media/Edit_icons.c8a83e56df4e8a576ffa8b7694cd3770.svg";
export { ForwardRef as ReactComponent };